import { useEffect, useState } from "react";
import "./sideindex.scss";

const sections = [
  { id: "about", label: "About" },
  { id: "numbers", label: "Numbers" },
  { id: "journey", label: "Journey" },
  { id: "contact", label: "Contact" },
];

export default function SideIndex() {
  const [active, setActive] = useState("");

  useEffect(() => {
    const targets = sections.map((s) => document.getElementById(s.id)).filter(Boolean);
    if (!targets.length) return undefined;
    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) setActive(entry.target.id);
        });
      },
      { rootMargin: "-40% 0px -50% 0px", threshold: 0 }
    );
    targets.forEach((t) => observer.observe(t));
    return () => observer.disconnect();
  }, []);

  return (
    <nav className="side-index" aria-label="On this page">
      <ol>
        {sections.map((s) => (
          <li key={s.id}>
            <a href={`/#${s.id}`} className={active === s.id ? "is-active" : ""} aria-current={active === s.id ? "true" : undefined}>
              <span className="side-index-dot" aria-hidden="true"></span>
              <span className="side-index-label">{s.label}</span>
            </a>
          </li>
        ))}
      </ol>
    </nav>
  );
}
